import { GetLocalitiesByPostalCode, GetLocalitiesByPostalCodeToken } from "$src/application/map/queries/GetLocalitiesByPostalCode";
import { Locality } from "$src/domain/map/Locality";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchPostalCodeParams {
    queryKey: ['postalcodes', string, string];
}

export async function fetchPostalCode( { queryKey } : FetchPostalCodeParams): Promise<Locality[]> {
    const [_, countryCode, codeQuery] = queryKey;
    if( codeQuery.length > 0 && countryCode.length > 0)
    {
        const query = container.resolve<GetLocalitiesByPostalCode>(GetLocalitiesByPostalCodeToken);
        return query.execute(countryCode, codeQuery);
    }
    else
        return [];
}

export function usePostalCode(countryCode: string, codeQuery: string) {
    return useQuery<Locality[], Error, Locality[], ['postalcodes', string, string]>(
        ['postalcodes', countryCode, codeQuery], 
        fetchPostalCode,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}